import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default from 'react';
import { withTheme } from 'styled-components';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var target = null;

var modifyDataAmountBy = function modifyDataAmountBy(element, amount) {
  element.setAttribute('data-amount', String(Number(element.getAttribute('data-amount')) + amount));
}; // https://stackoverflow.com/a/8831937/1065786


var hashCode = function hashCode(str) {
  var hash = 0;

  if (str.length === 0) {
    return String(hash);
  }

  for (var i = 0; i < str.length; i += 1) {
    var _char = str.charCodeAt(i);

    hash = (hash << 5) - hash + _char;
    hash = hash & hash; // Convert to 32bit integer
  }

  return String(hash);
};

var GlobalStyle = /*#__PURE__*/function (_React$Component) {
  _inherits(GlobalStyle, _React$Component);

  var _super = _createSuper(GlobalStyle);

  function GlobalStyle() {
    var _this;

    _classCallCheck(this, GlobalStyle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "cssStr", []);

    _defineProperty(_assertThisInitialized(_this), "interpolations", []);

    _defineProperty(_assertThisInitialized(_this), "hash", '');

    _defineProperty(_assertThisInitialized(_this), "getTarget", function () {
      /**
       * Due to this bug in chromium https://bugs.chromium.org/p/chromium/issues/detail?id=336876.
       * We need to put font face definitions in the root element because if they are put in a
       * shadow dom the fonts will not load.
       */
      var cssContainsFontFaceDefinitions = (_this.interpolations || []).filter(function (str) {
        if (typeof str !== 'string') {
          return false;
        }

        return str.includes('@font-face');
      }).length > 0;

      if (target && !cssContainsFontFaceDefinitions) {
        return target;
      }

      if (document && document.querySelector('head')) {
        return document.querySelector('head');
      }

      return null;
    });

    return _this;
  }

  _createClass(GlobalStyle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$getTarget, _this$getTarget2;

      var css = this.getCssAndHash();
      var existingStyleTag = (_this$getTarget = this.getTarget()) === null || _this$getTarget === void 0 ? void 0 : _this$getTarget.querySelector("[data-id=\"".concat(css.hash, "\"]"));

      if (existingStyleTag) {
        modifyDataAmountBy(existingStyleTag, 1);
        return;
      }

      this.hash = css.hash;
      (_this$getTarget2 = this.getTarget()) === null || _this$getTarget2 === void 0 ? void 0 : _this$getTarget2.appendChild(this.createStyleTag(css));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$getTarget3, _this$getTarget4;

      var css = this.getCssAndHash();
      var existingStyleTag = (_this$getTarget3 = this.getTarget()) === null || _this$getTarget3 === void 0 ? void 0 : _this$getTarget3.querySelector("[data-id=\"".concat(css.hash, "\"]"));

      if (existingStyleTag) {
        return;
      }

      this.hash = css.hash;
      (_this$getTarget4 = this.getTarget()) === null || _this$getTarget4 === void 0 ? void 0 : _this$getTarget4.appendChild(this.createStyleTag(css));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$getTarget5;

      var existingStyleTag = (_this$getTarget5 = this.getTarget()) === null || _this$getTarget5 === void 0 ? void 0 : _this$getTarget5.querySelector("[data-id=\"".concat(this.hash, "\"]"));

      if (existingStyleTag) {
        if (Number(existingStyleTag.getAttribute('data-amount')) === 1) {
          var _this$getTarget6;

          (_this$getTarget6 = this.getTarget()) === null || _this$getTarget6 === void 0 ? void 0 : _this$getTarget6.removeChild(existingStyleTag);
        } else {
          modifyDataAmountBy(existingStyleTag, -1);
        }

        this.hash = '';
      }
    }
  }, {
    key: "getCssAndHash",
    value: function getCssAndHash() {
      var _this2 = this;

      var obj = {
        css: '',
        hash: ''
      };
      obj.css = this.cssStr.map(function (str, i) {
        var val = _this2.interpolations[i] || '';

        if (typeof val === 'function') {
          val = val(_this2.props);
        }

        if (typeof val !== 'string') {
          val = '';
        }

        return "".concat(str).concat(val);
      }).join('');
      obj.hash = hashCode(obj.css);
      return obj;
    }
  }, {
    key: "createStyleTag",
    value: function createStyleTag(css) {
      var style = document.createElement('style');
      style.setAttribute('data-id', String(this.hash));
      style.setAttribute('data-amount', '1');
      style.appendChild(document.createTextNode(css.css));
      return style;
    }
  }, {
    key: "createStyleTagAsJSX",
    value: function createStyleTagAsJSX(css) {
      return /*#__PURE__*/React__default.createElement("style", {
        "data-id": String(this.hash),
        dangerouslySetInnerHTML: {
          __html: css.css
        }
      });
    }
  }, {
    key: "renderSSR",
    value: function renderSSR() {
      var css = this.getCssAndHash();
      return this.createStyleTagAsJSX(css);
    }
  }, {
    key: "render",
    value: function render() {
      if (typeof window !== 'undefined') {
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
      }

      return this.renderSSR();
    }
  }]);

  return GlobalStyle;
}(React__default.Component);
/**
 * An explanation is required for this.
 *
 * There is a bug in styled-components that stops us using createGlobalStyle. So we have made an
 * override (see method with the same name in this file).
 *
 * For shadow dom usage we need to be able to set the target for where `<style></style` elements
 * will be created. Call this method with the target element within your _app.tsx before rendering.
 */


var setStyledComponentsTarget = function setStyledComponentsTarget(targetEl) {
  target = targetEl;
};
var createGlobalStyle = function createGlobalStyle(cssStr) {
  for (var _len2 = arguments.length, interpolations = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    interpolations[_key2 - 1] = arguments[_key2];
  }

  return withTheme( /*#__PURE__*/function (_GlobalStyle) {
    _inherits(GlobalStyle2, _GlobalStyle);

    var _super2 = _createSuper(GlobalStyle2);

    function GlobalStyle2() {
      var _this3;

      _classCallCheck(this, GlobalStyle2);

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      _this3 = _super2.call.apply(_super2, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this3), "cssStr", cssStr);

      _defineProperty(_assertThisInitialized(_this3), "interpolations", interpolations);

      return _this3;
    }

    return _createClass(GlobalStyle2);
  }(GlobalStyle));
};

export { createGlobalStyle, setStyledComponentsTarget };
//# sourceMappingURL=global-styles.js.map
